import { render, staticRenderFns } from "./InventoryCostReport.vue?vue&type=template&id=4b1a95d2&scoped=true"
import script from "./InventoryCostReport.vue?vue&type=script&lang=js"
export * from "./InventoryCostReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryCostReport.vue?vue&type=style&index=0&id=4b1a95d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a95d2",
  null
  
)

export default component.exports